<!-- 按钮配置 -->
<template>
  <basic-container>
    <div class="buttonSetup">
      <el-form ref="form" :model="form" label-width="200px" label-position="left" v-loading="loading">
        <!-- <span class="demonstration">表格配置</span>
        <el-divider></el-divider> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否出现多选框">
              <el-select v-model="form.selection" placeholder="请选择是否显示">
                <el-option label="否" value="false"></el-option>
                <el-option label="是" value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="拓展配置">
              <el-input v-model="extendedProp" type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容如: formTip=***&tableTip=****"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span class="demonstration">操作栏配置</span>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="11">
            <el-form-item label="是否显示行操作栏">
              <el-select v-model="form.menu" placeholder="请选择是否显示">
                <el-option label="否" value="false"></el-option>
                <el-option label="是" value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="11">
            <el-form-item label="操作栏对齐方式">
              <el-select v-model="form.menuAlign" placeholder="请选择对齐方式">
                <el-option label="居左" value="left"></el-option>
                <el-option label="居中" value="center"></el-option>
                <el-option label="居右" value="right"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="操作栏宽度">
              <el-input v-model="form.menuWidth" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="序列">
              <el-input v-model="tableSeq" placeholder="请输入序列"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <span class="demonstration">搜索配置</span>
        <el-divider></el-divider> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="mini">{{title}}</el-button>
          <el-button @click="onCancel" size="mini">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </basic-container>
</template>

<script>
import { addButton, seeButton ,updateButton,} from "@/api/table/table";
export default {
  components: {},
  data() {
    return {
        title:"配置",
        id:"", //表id
        loading:false,
        extendedProp:'',
        tableSeq:'', //序列
        // 表单内容
        form: {
          modelId:"",
          menu: "",
          menuWidth:"", //操作栏宽度
          menuAlign: "",
          searchMenuSpan:4,
          selection:"",
        },
    };
  },
  computed: {},
  watch:{},
  //方法集合
  methods: {
    // 点击提交
    onSubmit() {
      this.loading=true;
      addButton({properties:JSON.stringify(this.form),extendedProp:this.extendedProp,tableSeq:this.tableSeq,id:this.id} ).then(() => {
        this.$message.success("操作成功!");
        this.onCancel();
      }, e => {
        this.loading=false;
      });
    },
    // 点击取消
    onCancel() {
      // 关闭自己
      this.$store.commit("DEL_TAG", {value:this.$route.fullPath});
      this.$router.go(-1);
    },
  },
  created() {},
  mounted() {},
  activated() {
    this.loading=true;
    this.id=this.$route.query.id;
    seeButton(this.id).then((res) => {
      if(res.data.data.properties){
        this.form= JSON.parse(res.data.data.properties) 
        this.extendedProp= res.data.data.extendedProp;
        this.tableSeq= res.data.data.tableSeq;
      }
      this.loading=false;
    }, e => {
      this.loading=false;
    });
  } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
</style>